import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr";
import { German } from "flatpickr/dist/l10n/de";
import { Dutch } from "flatpickr/dist/l10n/nl";
import { english } from "flatpickr/dist/l10n/default";
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/en-ie';
import 'moment/locale/nl';
import utils from './utils';
'use strict';

class DatePickers {
  constructor() {
    this.url = "/api/dates";
    this.inDates = [];
    this.outDates = [];
    this.resortsInput = document.querySelector('#search-resorts');
    this.typeInput = document.querySelector('#edit-type');
    this.capacityInput = document.querySelector('#edit-peoples');
    this.arrivalInput = document.querySelector('#edit-arrival');
    this.arrivalInputBeautify = document.querySelector('#edit-arrival-beautify');
    this.departureInput = document.querySelector('#edit-departure');
    this.departureInputBeautify = document.querySelector('#edit-departure-beautify');
    this.clearInputDates = this.clearDates.bind(this);

    /*## I18N ##*/
    if (!window.currentLang) {
      utils.setCurrentLang();
    }
    this.locales = {
      fr: French,
      en: english,
      de: German,
      "en-ie": english,
      nl: Dutch,
    };
    moment.locale(window.currentLang);
    this.events();
  }

  getApiUrl(queryParameters) {
    if (Object.keys(queryParameters).length > 0) {
      return `${this.url}?${new URLSearchParams({...queryParameters})}`;
    }

    return this.url;
  }

  events() {
    this.refreshData();
    this.getDates({
      resorts: `[${this.resortsInput.value}]`,
      type: this.typeInput.value,
      capacity: this.capacityInput.getAttribute('data-total-capacity'),
    }).then(rep => {
      this.initCalendars();
    });

    utils.mq.sm.addListener(mq => {
      if (mq.matches) {
        this.departureCalendar.set('showMonths', 1);
        this.arrivalCalendar.set('showMonths', 1);
      } else {
        this.departureCalendar.set('showMonths', 2);
        this.arrivalCalendar.set('showMonths', 2);
      }
    });

    window.onpageshow = (event) => {
      if (utils.mq.sm.matches) {
        var changeEvent = new Event('change');
        
        if (this.arrivalInput.value) {
          this.arrivalInputBeautify.value = moment(this.arrivalInput.value).format('ll');
          this.arrivalInput.dispatchEvent(changeEvent);
        }

        if (this.departureInput.value) {
          this.departureInputBeautify.value = moment(this.departureInput.value).format('ll');
          this.departureInput.dispatchEvent(changeEvent);
        }
      }
    };
  }

  refreshData() {
    this.resortsInput.addEventListener('change', e => {
      this.getDates({
        resorts: `[${e.currentTarget.value}]`,
        type: this.typeInput.value,
        capacity: this.capacityInput.getAttribute('data-total-capacity'),
      }).then(rep => {
        this.initCalendars();
      });
    });
    this.typeInput.addEventListener('change', e => {
      this.getDates({
        resorts: `[${this.resortsInput.value}]`,
        type: e.currentTarget.value,
        capacity: this.capacityInput.getAttribute('data-total-capacity'),
      }).then(rep => {
        this.initCalendars();
      });
    });
    this.capacityInput.addEventListener('change', e => {
      this.getDates({
        resorts: `[${this.resortsInput.value}]`,
        type: this.typeInput.value,
        capacity: e.currentTarget.getAttribute('data-total-capacity'),
      }).then(rep => {
        this.initCalendars();
      });
    });
    /* document.querySelector('.js-input-counter-label').addEventListener('counterChange', e => {
      console.log('coutner  change');
    }); */
  }

  clearDates(event) {
    event.preventDefault();
    const calendarInputActive = document.querySelector('.flatpickr-input.active');
    if (event.key === "Delete" && calendarInputActive) {
      if (calendarInputActive.getAttribute('id') === 'edit-arrival') {
        this.arrivalInput.value = '';
        this.arrivalInputBeautify.value = '';
      } else if (calendarInputActive.getAttribute('id') === 'edit-departure') {
        this.departureInput.value = '';
        this.departureInputBeautify.value = '';
      }
    }
  }

  /**
   * @param {object} calendarToSet Calendar to set
   * @param {object} calendarSource source calendar for setting calendarToSet
   */
  createRange(calendarToSet, calendarSource) {
    const calendarToSetContainer = calendarToSet.calendarContainer;
    // is source calendar is departure calendar
    const isCalendarToSetArrival = calendarToSet.element.matches('#edit-arrival');

    // RESET CALENDAR_TO_SET
    /* If there is endRange element in to set calendar we remove it */
    if (calendarToSetContainer.querySelector('.endRange')) {
      calendarToSetContainer.querySelector('.endRange').classList.remove('endRange');
    }

    /* If there is in range elements in to set calendar we remove them */
    if (calendarToSetContainer.querySelectorAll('.inRange').length > 0) {
      calendarToSetContainer.querySelectorAll('.inRange').forEach(el => {
        el.classList.remove('inRange');
      });
    }

    // SET CALENDAR_TO_SET
    if (calendarToSet.selectedDates[0] && !calendarToSet.selectedDateElem.classList.contains('.hidden')) {
      calendarToSet.selectedDateElem.classList.add(isCalendarToSetArrival ? 'startRange' : 'endRange');
    }

    if (calendarSource.selectedDates[0]) {
      if (!isCalendarToSetArrival || (isCalendarToSetArrival && calendarToSet.selectedDates[0])) {
        // set the endRange class after
        const ariaLabel = calendarSource.selectedDateElem.getAttribute('aria-label');
        const rangeElem = calendarToSetContainer.querySelector(`[aria-label='${ariaLabel}']:not(.hidden)`);

        if (rangeElem) {
          rangeElem.classList.add(isCalendarToSetArrival ? 'endRange' : 'startRange');
  
          if (calendarToSet.selectedDates[0]) {
            /* Setting in range cells */
            utils.nextUntil(calendarToSetContainer.querySelector(".startRange"), '.endRange').forEach(el => {
              el.classList.add('inRange');
            });

            utils.prevUntil(calendarToSetContainer.querySelector(".endRange"), '.startRange').forEach(el => {
              el.classList.add('inRange');
            });
          }
        }
      } else {
        calendarToSet.selectedDateElem.classList.remove(isCalendarToSetArrival ? 'startRange' : 'endRange');
      }
    }
  }

  initCalendars() {
    this.departureCalendar = new flatpickr(this.departureInput, {
      locale: this.locales[window.currentLang],
      dateFormat: "Y-m-d",
      showMonths: utils.mq.sm.matches ? 1 : 2,
      static: true,
      enable: this.outDates,
      onReady: (selectedDates, dateStr, instance) => {
        const selectedDateStr = dateStr || this.departureInput.value
        if (selectedDateStr !== '') {
          this.departureInputBeautify.value = moment(selectedDateStr).format('ll');

          if (this.outDates.includes(selectedDateStr)) {
            instance.setDate(dateStr);
          }
        } else {
          this.arrivalInput.value = '';
          this.arrivalInputBeautify.value = '';
          this.departureInput.value = '';
          this.departureInputBeautify.value = '';
        }
      },
      onOpen: [
        (selectedDates, dateStr, instance) => {
          this.departureInput.focus();
          if (this.arrivalCalendar.selectedDateElem) {
            /* Place departure calendar at the next good month */
            if (dateStr !== '' && this.outDates[dateStr]) {
              instance.jumpToDate(dateStr);
            } else if (dateStr === '' && this.outDates.length > 0) {
              instance.jumpToDate(this.outDates[0]);
            } else {
              instance.jumpToDate(this.arrivalCalendar.selectedDates[0]);
            }
            this.createRange(this.departureCalendar, this.arrivalCalendar);
          } else if (this.departureInput.value) {
            instance.jumpToDate(this.departureInput.value);
          }
          window.addEventListener('keydown', this.clearInputDates);
          this.departureInput.closest('.js-date-picker-wrapper').classList.add('zi-5');
        },
      ],
      onChange: [
        (selectedDates, dateStr, instance) => {
          if (dateStr !== '') {
            this.departureInputBeautify.value = moment(dateStr).format('ll');
          } else {
            this.departureInputBeautify.value = '';
          }

          var changeEvent = new Event('change');
          this.departureInput.dispatchEvent(changeEvent);
        },
      ],
      onClose: [
        (selectedDates, dateStr, instance) => {
          window.removeEventListener('keydown', this.clearInputDates);
          this.departureInput.closest('.js-date-picker-wrapper').classList.remove('zi-5');
        }
      ]
    });

    this.arrivalCalendar = new flatpickr(this.arrivalInput, {
      locale: this.locales[window.currentLang],
      dateFormat: "Y-m-d",
      showMonths: utils.mq.sm.matches ? 1 : 2,
      static: true,
      minDate: 'today',
      enable: this.inDates,
      onReady: (selectedDates, dateStr, instance) => {
        const selectedDateStr = dateStr || this.arrivalInput.value;
        if (dateStr !== '') {
          this.arrivalInputBeautify.value = moment(selectedDateStr).format('ll');
        }
      },
      onOpen: [
        (selectedDates, dateStr, instance) => {
          this.arrivalInput.focus();
          if (selectedDates.length > 0) {
            instance.jumpToDate(selectedDates[0]);
          } else if (this.arrivalInput.value) {
            instance.jumpToDate(this.arrivalInput.value);
          }
          this.createRange(this.arrivalCalendar, this.departureCalendar);
          window.addEventListener('keydown', this.clearInputDates);
          this.arrivalInput.closest('.js-date-picker-wrapper').classList.add('zi-5');
        }
      ],
      onClose: [
        (selectedDates, dateStr, instance) => {
          window.removeEventListener('keydown', this.clearInputDates);
          this.arrivalInput.closest('.js-date-picker-wrapper').classList.remove('zi-5');
        }
      ],
      onDayCreate: [(dObj, dStr, fp, dayElem) => {}],
      onChange: [
        (selectedDates, dateStr, instance) => {
          if (dateStr !== '') {
            this.arrivalInputBeautify.value = moment(dateStr).format('ll');
          }

          this.dates.every(date => {
            if (date.inDate == dateStr) {
            // if (date.inDate == dateStr) {
              this.outDates = date.outDate;

              return false;
            }

            return true;
          });

          this.departureCalendar.clear();
          this.departureCalendar.set('enable', this.outDates);
          this.departureCalendar.jumpToDate(this.outDates[0]);
          if (this.arrivalInput.value.trim().length !== 0) {
            this.departureCalendar.open();
          }

          var changeEvent = new Event('change');
          this.arrivalInput.dispatchEvent(changeEvent);
        },
      ]
    });
    // this.arrivalCalendar.clear()
  }

  async getDates(params = {}) {
    return await fetch(this.getApiUrl(params)).then(response => {
      return response.json();
    }).then(data => {
      this.dates = data;
      this.inDates = this.dates.map(date => {
        return date.inDate;
      });
      if (this.arrivalInput.value !== '') {
        this.dates.every(date => {
          if (date.inDate == this.arrivalInput.value) {
            this.outDates = date.outDate;
            
            return false;
          }

          return true;
        });
      }
    })
  }
}

if(document.querySelectorAll('.search-engine-calendar').length > 0) {
  const datePickers = new DatePickers()
}
